<template>
    <span>{{ label }}</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { Column } from '../types';

const props = defineProps<{
    entry: Record<string, any>;
    column: Column;
    options?: Record<string, unknown>;
}>();

const label = computed((): string => {
    const relation = (props.options?.relation as string) ?? props.column.slug.replace(/_id$/, '');
    const labelKey = (props.options?.labelKey as string) ?? 'name';

    const related = props.entry?.[relation];

    if (!related || typeof related !== 'object') {
        return '';
    }

    return related[labelKey] ?? '';
});
</script>
